import { EButtonIntents } from '@src/typings';
import { withTheme } from '../ThemeProvider';
import { StyledIconButton } from './styles';
import { IconButtonProps } from './types';

const IconButtonComponent = ({
    icon: Icon,
    intent = EButtonIntents.Filled,
    rounded = 'lg',
    size = 'md',
    hiddenLabel,
    className,
    ...props
}: IconButtonProps) => {
    return (
        <StyledIconButton
            intent={intent}
            rounded={rounded}
            size={size}
            className={className}
            {...props}
        >
            {hiddenLabel && <p className="sr-only">{hiddenLabel}</p>}
            <Icon aria-hidden="true" />
        </StyledIconButton>
    );
};

export const IconButton = withTheme(IconButtonComponent);
